"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _MarkerClusterer = require("./MarkerClusterer");

var _MarkerClusterer2 = _interopRequireDefault(_MarkerClusterer);

var _LocationsUtil = require("../../utils/LocationsUtil");

var _UserUtil = require("../../utils/UserUtil");

var _AdsUtil = require("../../utils/AdsUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdsMap = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(AdsMap, _Component);

  function AdsMap() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AdsMap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AdsMap.__proto__ || (0, _getPrototypeOf2.default)(AdsMap)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      map: null,
      markerClusterer: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AdsMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var map = new google.maps.Map(this.mapNode, {
        center: (0, _LocationsUtil.getCoordinates)("helsinki"),
        zoom: 12,
        maxZoom: 14,
        disableDefaultUI: true,
        zoomControl: true
      });
      this.setState({ map: map }, function () {
        _this2.createMarkers();
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!this.isAdsSame(this.props.ads, prevProps.ads) && this.state.markerClusterer) {
        this.state.markerClusterer.clearMarkers();
        if (this.props.ads.length) {
          this.createMarkers();
        }
      }
    }
  }, {
    key: "isAdsSame",
    value: function isAdsSame(ads, prevAds) {
      return ads.length === prevAds.length && ads.every(function (ad, i) {
        return ad === prevAds[i];
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement("div", { ref: function ref(node) {
          return _this3.mapNode = node;
        }, className: "map" });
    }
  }, {
    key: "createMarkers",
    value: function createMarkers() {
      var _this4 = this;

      var markers = void 0;
      var paidUser = (0, _UserUtil.isPaidUser)(this.props.user);

      if (paidUser) {
        markers = this.createAccurateMarkers();
      } else {
        markers = this.createInaccurateMarkers();
      }

      var options = this.getClustererOptions(paidUser);
      var markerClusterer = new _MarkerClusterer2.default(this.state.map, markers, options);

      if (!paidUser) {
        google.maps.event.addListener(markerClusterer, "clusterclick", function (cluster) {
          var infoWindow = _this4.createClusterInfoWindow(cluster);
          infoWindow.open(_this4.state.map);
        });
      }

      this.setState({ markerClusterer: markerClusterer }, function () {
        if (markers.length) {
          _this4.fitBounds();
        }
      });
    }
  }, {
    key: "createAccurateMarkers",
    value: function createAccurateMarkers() {
      var _this5 = this;

      var markers = [];
      this.props.ads.forEach(function (ad) {
        if ((0, _LocationsUtil.legitCoordinates)(ad.latitude, ad.longitude)) {
          var marker = _this5.createMarker({
            lat: ad.latitude,
            lng: ad.longitude
          });
          var infoWindow = _this5.createAccurateInfoWindow(ad);
          marker.addListener("click", function () {
            infoWindow.open(_this5.state.map, marker);
          });
          markers.push(marker);
        }
      });
      return markers;
    }
  }, {
    key: "createInaccurateMarkers",
    value: function createInaccurateMarkers() {
      var _this6 = this;

      var markers = [];
      this.props.ads.forEach(function (ad) {
        var coordinates = (0, _LocationsUtil.getCoordinates)(ad.postal_area);
        if ((0, _LocationsUtil.legitCoordinates)(coordinates.lat, coordinates.lng)) {
          var marker = _this6.createMarker(coordinates);
          marker.postal_area = ad.postal_area;
          var infoWindow = _this6.createInaccurateInfoWindow(ad);
          marker.addListener("click", function () {
            infoWindow.open(_this6.state.map, marker);
          });
          markers.push(marker);
        }
      });
      return markers;
    }
  }, {
    key: "createMarker",
    value: function createMarker(position) {
      return new google.maps.Marker({
        map: this.state.map,
        draggable: false,
        position: position,
        icon: "/img/maaporssi-map-marker.png"
      });
    }
  }, {
    key: "createAccurateInfoWindow",
    value: function createAccurateInfoWindow(ad) {
      var soilTypes = this.props.soilTypes;

      var soilType = (0, _AdsUtil.getSoilTypeName)(ad, soilTypes);
      var content = "\n      <p class=\"marker-window\">\n        <b><span>" + soilType + "</span></b>\n        <span>" + ad.soil_amount + " t</span>\n        <span>" + ad.postal_area + "</span>\n      </p>\n    ";
      return new google.maps.InfoWindow({ content: content });
    }
  }, {
    key: "createInaccurateInfoWindow",
    value: function createInaccurateInfoWindow(ad) {
      var content = "\n      <p class=\"marker-window\">\n        <b><span>" + ad.postal_area + "</span></b>\n        <span>1 ilmoitus</span>\n      </p>\n    ";
      return new google.maps.InfoWindow({ content: content });
    }
  }, {
    key: "createClusterInfoWindow",
    value: function createClusterInfoWindow(cluster) {
      var markers = cluster.getMarkers();
      var content = "\n      <p class=\"marker-window\">\n        <b><span>" + markers[0].postal_area + "</span></b>\n        <span>" + markers.length + " ilmoitusta</span>\n      </p>\n    ";
      var position = cluster.getCenter();
      var pixelOffset = new google.maps.Size(-2, -38);
      return new google.maps.InfoWindow({ content: content, position: position, pixelOffset: pixelOffset });
    }
  }, {
    key: "fitBounds",
    value: function fitBounds() {
      var markers = this.state.markerClusterer.getMarkers();
      var bounds = new google.maps.LatLngBounds();
      markers.forEach(function (marker) {
        bounds.extend(marker.getPosition());
      });
      this.state.map.fitBounds(bounds);
    }
  }, {
    key: "getClustererOptions",
    value: function getClustererOptions(zoomOnClick) {
      var styles = [{
        url: "/img/maaporssi-map-marker.png",
        height: 46,
        width: 33,
        textColor: "#f7f7f7",
        textSize: 16,
        anchor: [6, 0],
        iconAnchor: [17.5, 40]
      }];

      return {
        maxZoom: 20,
        zoomOnClick: zoomOnClick,
        gridSize: 50,
        styles: styles
      };
    }
  }]);
  return AdsMap;
}(_react.Component), _class.propTypes = {
  ads: _react.PropTypes.array.isRequired,
  soilTypes: _react.PropTypes.array.isRequired,
  user: _react.PropTypes.object
}, _temp2);
exports.default = AdsMap;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/map/AdsMap.js
 ** module id = 1157
 ** module chunks = 0
 **/